import React, { useContext } from 'react';

import LazyLoad from 'react-lazyload';
import { withRouter } from 'react-router-dom'

import { useStore, getIsAuthenticated } from '../../Store'
import Hero from './Hero';
import Example from './Example'
import PullRequestCheck from './PullRequestCheck'
import Testimonial from '../../components/Testimonial'
import Seo from '../../components/Seo'
import Features from '../../components/Features'
import HowItWorks from '../../components/HowItWorks'
import ScrollSpy from '../../components/ScrollSpy'

import { defaultExamplePythonRepos } from '../../hooks/useOctokit'
import { useProduct } from '../../hooks/useProduct'



export default withRouter(function(props) {
  const { state } = useStore()
  const productDetails = useProduct()
 
  return (
    <ScrollSpy>
      <Seo
        title={'Avoid code review mistakes'} 
        description={`Find and fix Python or Django mistakes hidden in your Bitbucket Pull Requests.`}
        image={"/og-image/github.png"}
      />
      <Hero
        headline={'Fix more bugs during code review'}
        synopsis={'Python and Django improvements suggested right inside your Bitbucket pull request.'}
        linkUrl={productDetails.bitbucketMarketplaceLink}
        linkText={"Setup Bitbucket integration"}
        exampleCode={'NoMissingComma'}
      />
      <PullRequestCheck />
      <Features />
      <Testimonial />
      <Example />
    </ScrollSpy>
  )
})
